import { useNavigate } from "react-router-dom";
import { WorkOrderBoard } from "../../components/fleet/WorkOrderBoard";
import { ActionButton } from "../../components/common";
import { useAuth } from "../../context/AuthContext";

export default function MobileMechanic() {
  const { user, tenant, logout } = useAuth();
  const navigate = useNavigate();
  const leave = async () => { await logout(); navigate("/login"); };
  return <div className="min-h-screen bg-slate-50" data-testid="mobile-mechanic-page">
    <header className="border-b border-slate-200 bg-white px-4 py-3 flex flex-wrap justify-between gap-3 items-center">
      <div className="min-w-0"><p className="text-sm font-semibold text-[#84252F]" data-testid="mechanic-company-name">{tenant?.name}</p><p data-testid="mechanic-user-name" className="text-xs text-slate-500">{user?.name} · Mechanic</p></div>
      <ActionButton testId="mechanic-logout-button" variant="secondary" onClick={leave}>Sign Out</ActionButton>
    </header>
    <main className="max-w-7xl mx-auto p-4 sm:p-6">{tenant?.enabled_modules?.includes("fleet") ? <WorkOrderBoard mobile /> : <p role="alert" data-testid="mechanic-module-disabled">Fleet Logic is not enabled for this company. Contact your administrator.</p>}</main>
  </div>;
}
